import { useEffect, useState } from 'react';

const STORAGE_KEY = 'sidebar-collapsed';

// Sinkron ke localStorage supaya state collapse/expand sidebar tidak reset
// tiap refresh -- dipakai bareng di semua layout role (Admin/Mentor/Bumdes/DPL)
// biar konsisten.
const useSidebarCollapsed = () => {
  const [isCollapsed, setIsCollapsed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === '1',
  );

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, isCollapsed ? '1' : '0');
  }, [isCollapsed]);

  return [isCollapsed, setIsCollapsed];
};

export default useSidebarCollapsed;
